import { render } from "./OrderCard.vue?vue&type=template&id=b1554c9a&scoped=true"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=b1554c9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1554c9a"

export default script